// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"6f24cb2f","313":"00725d52","475":"b8822b56","739":"b72f4e89","815":"a6986696","960":"c938e839"}[chunkId] + ".css";
};